import { AccountManagementAnalytics, AnalyticsEventType, InteractionTrackingType, RegistrationType } from '@/services/analytics/platforms/adobe-analytics/models';
import { SaveDeliveryAddressEvent } from '@/services/analytics/events/save-delivery-address-event';
import { AdobeBaseEvent } from './adobe-base-event';
import { Store } from 'vuex';
import { AppState } from '@/store';
import { ServicesContainer } from '@/services';
import { RetrievalType } from '../constants';
import { getWebPageName } from '../helpers';

export class AdobeSaveDeliveryAddressEvent extends AdobeBaseEvent {
  event = AnalyticsEventType.LinkClicked;
  account = { ... this.account, loginType: RegistrationType.OrderWeb, accountInteraction: { value: 1 }, registrationType: RegistrationType.OrderWeb } as AccountManagementAnalytics;

  constructor(event: SaveDeliveryAddressEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);
    this.account.interactionName = InteractionTrackingType.AddAdressDetails;
    this.storeLocator.deliveryAddressSubmitted = { value: 1 };
    if (store.state.order.lastRetrievalType === RetrievalType.Pickup) {
      this.commerce.changeToDelivery = {'value': 1};
      this.web.webPageDetails.name = getWebPageName();
    }
    this.web.webInteraction = {
      linkModuleName: `Find A Chipotle|Add Address Details Modal|Deliver To This Address`,
      linkClicks: { value: 1 },
      type: 'other',
    };
  }
}